import React from 'react';
import Strips_Large_Cart from 'styles/staticAssets/images/Strips_Large_Cart.png';
import cart_header_mobile from 'styles/staticAssets/images/cart_header_mobile.png';
import { LOGIN_TEXT, NON_LOCALIZED_HEADER_TEXT, LOCALIZED_HEADER_TEXT } from '../constants/offersAndDealsConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { Config } from 'common/constants/SharedConstants';
import { login } from 'common/utilities/LoginUtils';

const DealsAndOffersHeader = props => {
  const { isLoggedIn = false, isMobile, isLocalized = false } = props;
  return (
    <div className='deals-offers-header' data-testid='offers-deals-header'>
      <div className='deals-offers-header-icon'>
        <img className='deals-stripe-icon' src={isMobile ? cart_header_mobile : Strips_Large_Cart} alt='' />
      </div>
      <div className='deals-header-text-container'>
        <h2 className='header-text' data-testid='header-text'>
          {isLoggedIn || isLocalized
            ? translateWithI18Next(LOCALIZED_HEADER_TEXT)
            : translateWithI18Next(NON_LOCALIZED_HEADER_TEXT)}
        </h2>
        {!isLoggedIn && (
          <p
            data-id={Config.HEADER_SIGN_IN_ATTR_DATA_ID}
            data-testid='offers-deals-signin-text'
            className='login-text'
            onClick={login}
          >
            {translateWithI18Next(LOGIN_TEXT)}
          </p>
        )}
      </div>
    </div>
  );
};

export default DealsAndOffersHeader;
